import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import type { GebiedLabel } from '@models/GebiedLabel'

import { StyledError } from '../../../theme/components/StyledError'
import { useDeleteLabel } from '../../hooks/useDeleteLabel'

export { DeleteLabel }

type Props = {
  label: GebiedLabel
  onClose: () => void
}

const DeleteLabel = ({ label, onClose }: Props) => {
  const { mutate: deleteLabel, error } = useDeleteLabel()

  const handleSubmit = () => {
    deleteLabel({ label }, { onSuccess: onClose })
  }

  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>Label verwijderen</DialogTitle>

      <DialogContent>
        <StyledError error={error} />

        <DialogContentText>
          {`Weet u zeker dat u het label ${label.label} wilt verwijderen uit ${label.gebiedscodeLabel}? Dit kunt u niet terugdraaien.`}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Nee
        </Button>

        <Button onClick={handleSubmit}>Ja</Button>
      </DialogActions>
    </Dialog>
  )
}
